import React, { Component } from 'react';
import Header from '../HeaderSection/Header';
import FooterSection from "../FooterSection/Footer";
import Breadcrumb from '../Blogs/Breadcrumb';

class TermsAndConditions extends Component {
    state = {};

    render() {
        return (
            <div>
                <div id="scrollUp" title="Scroll To Top">
                    <i className="fas fa-arrow-up" />
                </div>
                <div className="main">
                    <h3 className="nav-link" style={{ marginTop: '20px' }}>
                        Guess Who Never? - Terms and Conditions of Use
                    </h3>
                    <h5 className="nav-link" style={{ marginTop: '20px' }}>
                        Effective Date: April 30, 2025
                    </h5>
                    <h5 className="nav-link" style={{ marginTop: '20px' }}>End-User License Agreement (EULA)</h5>
<p className="nav-link" style={{ margin: '20px' }}>
  Before proceeding, you must agree to the End-User License Agreement (EULA). This agreement makes it clear that there is zero tolerance for objectionable content or abusive users. By accessing or using the Guess Who Never? mobile application, you confirm your acceptance of the EULA. If you do not agree to this EULA, you may not use the app.
</p>
<p className="nav-link" style={{ margin: '20px' }}>
  <strong>EULA Overview:</strong>
</p>
<p className="nav-link" style={{ margin: '20px' }}>
  <strong>Zero Tolerance for Objectionable Content:</strong> You must not post any content that is abusive, threatening, violent, discriminatory, or illegal. Violations will result in immediate suspension or permanent termination of your account.
</p>
<p className="nav-link" style={{ margin: '20px' }}>
  <strong>Abusive Users:</strong> Users found engaging in abusive behavior will be banned without notice.
</p>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        These Terms and Conditions of Use ("T&C") govern the usage of the "Guess Who Never?" mobile application ("the Application") provided by Moussa Harkous ("the Developer"). By accessing or using the Application, all users ("User") agree to be legally bound by these T&C.

                        IF YOU DO NOT ACCEPT THESE TERMS, DO NOT USE THE APPLICATION.

                        The Developer reserves the right to amend these T&C at any time. The most recent version of the T&C governs all usage of the Application.
                    </p>

                    <h5 className="nav-link" style={{ marginTop: '20px' }}>Article 1: Legal Information</h5>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        The "Guess Who Never?" Application is published by:
                        <br />Moussa Harkous
                        <br />Email: moussa@furrbud.com
                    </p>

                    <h5 className="nav-link">Article 2: Access to the Application</h5>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        The Application is accessible to all Users with an internet connection. All connection costs remain the User’s responsibility.

                        The Application is intended for users aged 17 and above. By using the Application, you confirm that you meet this age requirement.

                        Game Modes:
                        <ul>
                            <li>Local Game Mode – play with friends on one device.</li>
                            <li>Online Game Mode – users connect across multiple devices via a session code.</li>
                            <li>Custom Mode – players can create their own question list.</li>
                        </ul>
                    </p>

                    <h5 className="nav-link">Article 3: Free and Premium Content</h5>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        <strong>Free Content:</strong> Access to limited question packs across multiple categories.

                        <strong>Premium Content:</strong> Subscribers gain access to exclusive, high-quality question packs and advanced features.

                        <strong>Subscription Plans:</strong>
                        <ul>
                            <li>Weekly: $5.99 (3-day free trial for first-time users)</li>
                            <li>Monthly: $9.99</li>
                            <li>Yearly: $39.99</li>
                        </ul>

                        Payments are processed through the user’s app store account and subscriptions auto-renew unless canceled 24 hours before renewal. Subscriptions can be managed through the platform’s settings.

                        Trial periods must also be canceled at least 24 hours before renewal to avoid charges.
                    </p>

                    <h5 className="nav-link">Article 4: User Responsibilities</h5>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        Users must adhere to all laws and these T&C. Users can enter a nickname and select or upload an avatar.

                        Users are solely responsible for the content they submit. In multiplayer mode, answers and behavior are not moderated—play with people you trust.

                        Prohibited actions:
                        <ul>
                            <li>Reverse-engineering the app</li>
                            <li>Copying or redistributing content</li>
                            <li>Disrupting the game experience for others</li>
                        </ul>
                    </p>

                    <h5 className="nav-link">Article 5: Developer Rights and Liability</h5>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        The Developer ensures all gameplay data is temporary and removed after the session ends, with no personal data retained unless required for functionality.

                        The Developer is not responsible for technical issues, network failures, or content discomfort. Use is at the User’s own risk.
                    </p>

                    <h5 className="nav-link">Article 6: Intellectual Property</h5>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        All content (design, logic, assets) belongs to Moussa Harkous. Unauthorized reuse or duplication may result in legal action.
                    </p>

                    <h5 className="nav-link">Article 7: Updates and Service Interruption</h5>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        The Developer may modify or suspend the Application at any time to add features or improve performance.
                    </p>

                    <h5 className="nav-link">Article 8: Third-Party Links</h5>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        The Application may include links to third-party services. The Developer is not liable for the content or use of those external sites.
                    </p>

                    <h5 className="nav-link">Article 9: Privacy and Data</h5>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        No personal information is stored long-term. Information such as player answers or usernames is used only during the session and then discarded unless explicitly saved by the user.
                    </p>

                    <h5 className="nav-link">Article 10: Duration</h5>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        These terms are valid indefinitely, starting from the User's first use of the Application.
                    </p>

                    <h5 className="nav-link">Article 11: Contact and Support</h5>
                    <p className="nav-link" style={{ margin: '20px' }}>
                        For support or feedback, please contact:
                        <br />Moussa Harkous
                        <br />moussa@furrbud.com
                        <br />+96178912776
                    </p>

                    <h5 className="nav-link">Thank you for playing Guess Who Never!</h5>
                </div>
            </div>
        );
    }
}

export default TermsAndConditions;
